import React, { useEffect, useState } from "react";
import Axios from "../../services/AxiosInstance";

const JobApplications = () => {

  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedRow, setExpandedRow] = useState(null);
  const [searchBy, setSearchBy] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [filteredApplications, setFilteredApplications] = useState([]);

  const cellStyle = {
    padding: "12px 18px",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    textAlign: "left"
  };

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {

    try {

      const res = await Axios.get("/api/jobs/applications");

      console.log("APPLICATION DATA:", res.data);

      if (res.data.success) {
        setApplications(res.data.data || []);

        setFilteredApplications(res.data.data || []);
      }

    } catch (error) {

      console.log("FETCH ERROR:", error);

    } finally {

      setLoading(false);

    }
  };

  const handleSearch = () => {

  if (!searchBy || !searchValue) {
    setFilteredApplications(applications);
    return;
  }

  const filtered = applications.filter((app) => {

    if (searchBy === "jobId") {
      return app.jobId?.toLowerCase().includes(searchValue.toLowerCase());
    }

    if (searchBy === "companyId") {
      return app.companyId?.toLowerCase().includes(searchValue.toLowerCase());
    }

    if (searchBy === "studentId") {
      return app.studentId?.toLowerCase().includes(searchValue.toLowerCase());
    }

    if (searchBy === "wp_id") {
      return app.wp_id?.toLowerCase().includes(searchValue.toLowerCase());
    }

    if (searchBy === "contactNo") {
      return app.contactNo?.toLowerCase().includes(searchValue.toLowerCase());
    }

    return false;

  });

  setFilteredApplications(filtered);
};

const removeFilter = () => {
  setSearchBy("");
  setSearchValue("");
  setFilteredApplications(applications);
};

  // "N/A" comes from the submitting form as a literal value — treat it as empty
  const fmt = (v) => (v && v !== "N/A" ? v : "-");

  // DATE FORMAT
  const formatDate = (date) => {

    if (!date) return "-";

    try {

      let finalDate;

      if (date._seconds) {

        finalDate = new Date(date._seconds * 1000);

      } else if (date.seconds) {

        finalDate = new Date(date.seconds * 1000);

      } else {

        finalDate = new Date(date);

      }

      if (isNaN(finalDate.getTime())) return "-";

      return finalDate.toLocaleString("en-IN");

    } catch (err) {

      return "-";

    }
  };

  return (

    <div className="page-container">

      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
        JOB APPLICATIONS
      </h2>

      {/* FILTER SECTION */}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          marginBottom: "20px",
          flexWrap: "wrap",
          justifyContent: "center"
        }}
      >

        <h5 style={{ margin: 0 }}>
          Search By :
        </h5>

       <select
  value={searchBy}
  onChange={(e) => setSearchBy(e.target.value)}
  style={{
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    minWidth: "180px"
  }}
>

  <option value="">Select</option>

  <option value="jobId">Job ID</option>

  <option value="companyId">Company ID</option>

  <option value="studentId">Student ID</option>

  <option value="wp_id">WP ID</option>

  <option value="contactNo">Mobile No.</option>

</select>

        <input
  type="text"
  placeholder="Search..."
  value={searchValue}
  onChange={(e) => setSearchValue(e.target.value)}
  style={{
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    minWidth: "250px"
  }}
/>

<button
  onClick={handleSearch}
  style={{
    background: "#5b2be0",
    color: "#fff",
    border: "none",
    padding: "10px 22px",
    borderRadius: "8px",
    cursor: "pointer"
  }}
>
  Search
</button>

<button
  onClick={removeFilter}
  style={{
    background: "#0d6efd",
    color: "#fff",
    border: "none",
    padding: "10px 22px",
    borderRadius: "8px",
    cursor: "pointer"
  }}
>
  Remove Filter
</button>

      </div>

      {/* TABLE SCROLL */}

      <div
        style={{
          overflowX: "auto",
          overflowY: "auto",
          width: "100%",
          maxHeight: "650px",
          border: "1px solid #ddd",
          borderRadius: "8px",
          whiteSpace: "nowrap"
        }}
      >

        <table
          className="table"
          style={{
            minWidth: "1700px",
            tableLayout: "auto",
            borderCollapse: "separate",
            borderSpacing: "0 12px"
          }}
        >

          <thead>

            <tr>

              <th style={cellStyle}>Job ID</th>

              <th style={cellStyle}>Company ID</th>

              <th style={cellStyle}>Student ID</th>

              <th style={cellStyle}>Student Name</th>

              <th style={cellStyle}>WP ID</th>

              <th style={cellStyle}>Date</th>

              <th
                style={{
                  ...cellStyle,
                  paddingRight: "40px"
                }}
              >
                Email
              </th>

              <th
                style={{
                  ...cellStyle,
                  paddingRight: "40px"
                }}
              >
                Contact No.
              </th>

              <th style={cellStyle}>Action</th>

              <th style={cellStyle}>CV</th>

            </tr>

          </thead>

          <tbody>

            {loading ? (

              <tr>

                <td
                  colSpan="9"
                  style={{
                    textAlign: "center",
                    padding: "20px"
                  }}
                >
                  Loading...
                </td>

              </tr>

            ) : applications.length === 0 ? (

              <tr>

                <td
                  colSpan="9"
                  style={{
                    textAlign: "center",
                    padding: "20px"
                  }}
                >
                  No Applications Found
                </td>

              </tr>

            ) : (

              filteredApplications.map((app) => (

                <React.Fragment key={app.id}>

                  <tr>

                    <td style={cellStyle}>
                      {app.jobId || "-"}
                    </td>

                    <td style={cellStyle}>
                      {app.companyId || "-"}
                    </td>

                    <td style={cellStyle}>
                      {app.studentId || "-"}
                    </td>

                    <td style={cellStyle}>
                      {app.studentName || "-"}
                    </td>

                    <td style={cellStyle}>
                      {app.wp_id || "-"}
                    </td>

                    {/* DATE */}

                    <td
  style={{
    ...cellStyle,
    paddingRight: "80px",
    minWidth: "220px"
  }}
>
  {formatDate(app.appliedAt)}
</td>

                    {/* EMAIL */}

<td
  style={{
    ...cellStyle,
    paddingRight: "70px",
    minWidth: "260px"
  }}
>
  {app.email || "-"}
</td>

{/* CONTACT NO */}

<td
  style={{
    ...cellStyle,
    minWidth: "180px"
  }}
>
  {fmt(app.contactNo)}
</td>

                    {/* ACTION */}

                    <td style={cellStyle}>

                      <button
                        onClick={() =>
                          setExpandedRow(
                            expandedRow === app.id
                              ? null
                              : app.id
                          )
                        }
                        style={{
                          padding: "6px 14px",
                          border: "none",
                          borderRadius: "6px",
                          background: "#0d6efd",
                          color: "#fff",
                          cursor: "pointer"
                        }}
                      >
                        {expandedRow === app.id
                          ? "Hide"
                          : "View More"}
                      </button>

                    </td>

                    {/* CV */}

                    <td style={cellStyle}>

                      {app.cv ? (

                        <a
                          href={app.cv}
                          target="_blank"
                          rel="noreferrer"
                        >
                          View CV
                        </a>

                      ) : (

                        "-"

                      )}

                    </td>

                  </tr>

                  {/* EXPANDED DETAILS */}

{expandedRow === app.id && (

  <tr>

    <td
      colSpan="9"
      style={{
        background: "#f8f9fa",
        padding: "20px",
        borderRadius: "10px"
      }}
    >

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "18px",
          lineHeight: "28px"
        }}
      >

        {/* BASIC DETAILS */}

        <div>
          <strong>Job ID :</strong>{" "}
          {app.jobId || "-"}
        </div>

        <div>
          <strong>Company ID :</strong>{" "}
          {app.companyId || "-"}
        </div>

        <div>
          <strong>Student ID :</strong>{" "}
          {app.studentId || "-"}
        </div>

        <div>
         <strong>Student Name :</strong>{" "}
         {app.studentName || "-"}
        </div>

        <div>
          <strong>WP ID :</strong>{" "}
          {app.wp_id || "-"}
        </div>

        <div>
          <strong>Date :</strong>{" "}
          {formatDate(app.appliedAt)}
        </div>

        <div>
          <strong>Email :</strong>{" "}
          {app.email || "-"}
        </div>

        <div>
          <strong>Contact No. :</strong>{" "}
          {fmt(app.contactNo)}
        </div>

        <div>
          <strong>Address :</strong>{" "}
          {fmt(app.address)}
        </div>

        {/* EXTRA DETAILS */}

        <div>
          <strong>Last Salary :</strong>{" "}
          {fmt(app.lastSalary)}
        </div>

        <div>
          <strong>Expected Salary :</strong>{" "}
          {fmt(app.expectedSalary)}
        </div>

        <div>
          <strong>Notice Period :</strong>{" "}
          {fmt(app.noticePeriod)}
        </div>

        <div>
          <strong>DOB :</strong>{" "}
          {fmt(app.dob)}
        </div>

        <div>
          <strong>Location :</strong>{" "}
          {fmt(app.location)}
        </div>

        <div>
          <strong>Relevant Experience :</strong>{" "}
          {fmt(app.relevantExperience)}
        </div>

        <div>
          <strong>Current Company :</strong>{" "}
          {fmt(app.currentCompany)}
        </div>

      </div>

    </td>

  </tr>

)}

                </React.Fragment>

              ))

            )}

          </tbody>

        </table>

      </div>

    </div>

  );
};

export default JobApplications;